import {bootstrapApplication} from '@angular/platform-browser'
import {provideAppCore} from '@cart/src/app/app-shared'
import {AppComponent as AppComponentCart} from '@cart/src/app/app.component'
import {provideAppRouter} from './app/app.routes'

bootstrapApplication(AppComponentCart, {
  providers: provideAppCore(provideAppRouter),
}).catch(err => console.log(err))
